import CurrentUser from '../graphql/queries/CurrentUser'
import { useQuery } from '@apollo/client/react'
import useCurrentRoom from './useCurrentRoom'

export default function useUserIsCurator() {
    const { data } = useQuery(CurrentUser)
    const room = useCurrentRoom()
    const user = data?.user
    return room && room.admins.find( admin => admin.id === user?.id )
}
